import { graphql } from 'relay-runtime';

// Add experiment observation mutation
export const recordExperimentObservation = graphql`
  mutation ExperimentsRecordExperimentsObservationMutation($input: AddExperimentsObservationsInput!) {
    addExperimentsObservations(input: $input) {
      experimentsObservationNode {
        id
        observationType
        observation
        createdOn
        user {
          id
        }
        createdBy {
          id
        }
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`;

// Add experiment assignment mutation
export const recordExperimentAssignment = graphql`
  mutation ExperimentsRecordExperimentsAssignmentMutation($input: AddExperimentsFlagAssignmentInput!) {
    addExperimentsFlagAssignment(input: $input) {
      experimentsFlagHistoryNode {
        id
        user {
          id
        }
        flagName
        variantName
        createdOn
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`;

// Upsert experiment speculative data mutation
export const recordExperimentSpeculativeData = graphql`
  mutation ExperimentsRecordExperimentsSpeculativeDataMutation($input: UpsertExperimentsSpeculativeDataInput!) {
    upsertExperimentsSpeculativeData(input: $input) {
      experimentsSpeculativeDataNode {
        id
        flagName
        variantName
        payload {
          rootElement
        }
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`;

// Query for getting experiment flag history
export const getExperimentFlagHistory = graphql`
  query ExperimentsGetExperimentsFlagHistoryQuery($userId: String!) {
    userByPublicUserId(publicUserId: $userId) {
      experimentsFlagHistories {
        id
        flagName
        variantName
        createdOn
      }
    }
  }
`;

// Query for getting experiment observations
export const getExperimentObservations = graphql`
  query ExperimentsGetObservationsQuery($userId: String!) {
    userByPublicUserId(publicUserId: $userId) {
      experimentsObservations {
        id
        flagName
        variantName
        observationType
        observation
        createdOn
      }
    }
  }
`;

// Query for getting experiment speculative data
export const getExperimentSpeculativeData = graphql`
  query ExperimentsGetSpeculativeDataQuery($userId: String!) {
    userByPublicUserId(publicUserId: $userId) {
      experimentsSpeculativeData {
        id
        flagName
        variantName
        payload {
          rootElement
        }
        modifiedOn
      }
    }
  }
`;
